<p-panel [toggleable]="true" [header]="panelTitle" [(collapsed)]="collapsed" styleClass="panel-filter border mb-3">
  <ng-template #icons>
    <i [ngClass]="collapsed ? 'pi pi-chevron-circle-down' : 'pi pi-chevron-circle-up'" (click)="togglePanel()"></i>
  </ng-template>

  <div class="row mb-0 mb-lg-3">
    <ng-container *ngFor="let field of fields; let i = index">
      <div class='width-20 col-12 mb-3 mb-sm-0'>

        <!-- MultiSelect -->
        <ng-container *ngIf="field.type === 'multiselect'">
          <label [for]="'filter-field-' + i" class="form-label d-block">{{ field.label }}</label>
          <p-multiselect 
            [inputId]="'filter-field-' + i" 
            [options]="field.options" 
            [(ngModel)]="field.value"
            [optionLabel]="field.optionLabel || 'value'" 
            [optionValue]="field.optionValue || 'code'"
            [placeholder]="field.placeholder" 
            [maxSelectedLabels]="field.maxSelectedLabels || 1" 
            class="w-100"
            [showClear]="true"
            selectedItemsLabel="{0} items selected">
          </p-multiselect>
        </ng-container>

        <!-- Single Select -->
        <!-- <ng-container *ngIf="field.type === 'select'">
          <label [for]="'filter-field-' + i" class="form-label d-block">{{ field.label }}</label>
          <p-select 
            [inputId]="'filter-field-' + i" 
            [options]="field.options" 
            [(ngModel)]="field.value"
            [optionLabel]="field.optionLabel || 'value'" 
            [optionValue]="field.optionValue || 'code'"
            [placeholder]="field.placeholder" 
            class="w-100" 
            [showClear]="true"
            (onChange)="onFieldChange(field)">
          </p-select>
        </ng-container> -->

        <!-- Input Text -->
        <ng-container *ngIf="field.type === 'text'">
          <label [for]="'filter-field-' + i" class="form-label d-block">{{ field.label }}</label>
          <input 
            type="text" 
            pInputText 
            [id]="'filter-field-' + i" 
            [(ngModel)]="field.value" 
            class="w-100"
            [placeholder]="field.placeholder" />
        </ng-container>
      </div>
    </ng-container>
  </div>

  <div class="d-flex border-top pt-3">
    <!-- Updated to call onApplyFilter method instead of direct emit -->
    <p-button 
      label="Apply Filter" 
      (onClick)="onApplyFilter()" 
      styleClass="p-button-primary me-2" />
    
    <!-- Updated to call onClearFilter method -->
    <p-button 
      label="Clear Filter" 
      [link]="true" 
      (click)="onClearFilter()" 
      styleClass="px-0 reset-button" />
  </div>
</p-panel>